import React, {useState} from "react";
import UserInformationForm from "./UserInformationForm";
import DocumentInformationForm from "./DocumentInformationForm";


const InitConfirm = ({handleConfirm, accessToken, processInfo}) => {

    const [step, setStep] = useState(0)

    const [userInfo, setUserInfo] = useState(null);

    const handleUserInfo = (values) => {

        setUserInfo(values);
        setStep(step + 1);

    }

    const handleDocumentConfirm=(values)=>{
        const data = {...userInfo, ...values};
        handleConfirm(data);
    }

    return <div className="w-11/12 sm:w-10/12 min-h-screen flex justify-center items-center mx-auto  ">
        {step === 0 && <UserInformationForm processInfo={processInfo} onConfirm={handleUserInfo}/>}
        {step === 1 && <DocumentInformationForm handlePrev={() => setStep(0)}
                                                accessToken={accessToken}
                                                processInfo={processInfo}
                                                onConfirm={handleDocumentConfirm}/>}

    </div>
}
export default InitConfirm;